import {
  Box,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { HTMLAttributes } from "react";
import { BlogGrid } from "components/core/blog-grid";
import { useBlogs } from "hooks/useBlogs";
import { ReactComponent as Arrow } from "assets/Arrow.svg";
import styles from "./styles.module.scss";
import { Link, useParams } from "react-router-dom";
import { GetAllResponse } from "types/getAllResponse";
import { Blog } from "types/blogs";

type Props = {
  title: string;
  slice: number;
} & HTMLAttributes<HTMLDivElement>;

export const Blogs = ({ title, slice, ...props }: Props) => {
  const { id } = useParams();
  const { blogs } = useBlogs();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  let blogsFinal: GetAllResponse<Blog> = { ...blogs };

  const getFinalBlogs = () => {
    if (id) {
      const filtered = blogs.data.filter((blog) => blog.id !== Number(id));
      blogsFinal.data = filtered;
      blogsFinal.count = filtered.length;
    } else if (isSmallScreen) {
      const filtered = blogs.data.slice(0, 2);
      blogsFinal.data = filtered;
      blogsFinal.count = filtered.length;
    } else {
      const filtered = blogs.data.slice(0, slice);
      blogsFinal.data = filtered;
      blogsFinal.count = filtered.length;
    }
    return blogsFinal;
  };

  if (getFinalBlogs().count === 0) return <></>;

  return (
    <div {...props}>
      <Container maxWidth="lg" className="section">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: { xs: "12px", lg: "24px" },
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>

          <Link to="/blogs" className={styles.read__more}>
            <span>Read more</span>
            <Arrow />
          </Link>
        </Box>

        <BlogGrid blogResults={getFinalBlogs().data} />
      </Container>
    </div>
  );
};
